import { Link } from "react-router-dom";
import Modal from "react-modal";
import "../../../styles/Containers.css";
import { useState, useEffect } from "react";
import { DatePicker } from "react-advance-jalaali-datepicker";
import LoadingPage from "../../../components/LoadingPage";
import OneCategory from "../../../components/category";
import { useFetch } from "../../../custom/api";
import { toast } from "react-toastify";
import { OneCategorySearch } from "../../search/Search";
import Card from "../../../components/Card";
import CookingMode from "../../recipe/components/CookingMode";
import persian from "react-date-object/calendars/persian.js";
// import gregorian from "react-date-object/locales/gregorian_en.js";
import DateObject from "react-date-object";
// var  = require("date-object/calendars/cjs/gregorian");

export default function DietModal({
  showDiet,
  handleOpenDiet,
  handleCloseDiet,
  dietId,
  dietInfo,
  steps,
}) {
  const { myFetch } = useFetch();
  const [showDietDate, setShowDietDate] = useState(false);
  const todayEnglish = new Date();

  const tomorrow = todayEnglish.setDate(todayEnglish.getDate() + 1);
  let tomorrowObj = new Date(tomorrow);

  let tomorrowFormatted = new DateObject({
    date: new Date(tomorrow),
  })
    .setCalendar(persian)
    .format("YYYY-MM-DD");

  const [startDate, setStartDate] = useState(
    tomorrowObj.toISOString().substring(0, 10)
  );
  const [loading, setLoading] = useState(false);
  const [recipes, setRecipes] = useState(null);
  const [cookingModeDisplay, setCookingModeDisplay] = useState("none");

  useEffect(() => {
    const fetchData = async () => {
      const resp = await myFetch(`diet-plan/${dietId}`, { method: "GET" });
      const r = await resp.json();
      setRecipes(r);
    };
    if (dietId) {
      fetchData();
    }
  }, [dietId]);

  const handleOpenDietDate = () => {
    handleCloseDiet();
    setShowDietDate(true);
  };
  const handleCloseDietDate = () => {
    setShowDietDate(false);
    handleOpenDiet();
  };

  function formatDate(date) {
    const ff = new Date(date * 1000).toISOString().substring(0, 10);
    return ff;
  }

  function changeStart(unix, formatted) {
    setStartDate(formatDate(unix));
  }

  function DatePickerInput(props) {
    return <input className="subject-1 grey-1 b-grey-5" {...props} />;
  }

  async function handleSubmit() {
    let response = await myFetch("diet-plans/calendar", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        start_date: startDate,
        diet_plan_id: dietId,
      }),
    });

    let jsonResponse = await response.json();
    if (jsonResponse.status === "success") {
      toast.success(jsonResponse.message);
    } else {
      toast.error(jsonResponse.message);
    }
    handleCloseDietDate();
    handleCloseDiet();
  }

  return (
    <>
      <CookingMode
        steps={steps}
        display={cookingModeDisplay}
        setCookingModeDisplay={setCookingModeDisplay}
      ></CookingMode>
      <Modal
        isOpen={showDiet}
        onRequestClose={handleCloseDiet}
        className="modal"
        overlayClassName="overlay"
      >
        <div className="modal-header">
          <h2>برنامه غذایی</h2>
          <Link to="" onClick={handleCloseDiet}>
            <span className="icon-iconclose rectangle-1 heading-1 grey-3"></span>
          </Link>
        </div>
        <div className="modal-body">
          <p className="yekan grey-2">
            چند نمونه از غذاهایی که توی این برنامه داری اینها هستن :{" "}
          </p>
          <div className="card-grid max-height300">
            {recipes === null ? (
              <LoadingPage></LoadingPage>
            ) : (
              recipes.map((recipe) => {
                return <Card card={recipe} key={Math.random()} />;
              })
            )}
          </div>
        </div>
        <div className="modal-footer">
          {dietInfo && dietInfo.type === "prep" && (
            <Link
              onClick={() => {
                setCookingModeDisplay("block");
              }}
              className="marginBottom0-4r fill-container radius1-5"
            >
              رفتن به حالت پخت
            </Link>
          )}
          <Link
            // to={`/Diet?q=${tags}`}
            onClick={handleOpenDietDate}
            className="marginBottom0-4r fill-container radius1-5"
          >
            انتقال برنامه به تقویم
          </Link>
        </div>
      </Modal>

      <Modal
        isOpen={showDietDate}
        onRequestClose={handleCloseDietDate}
        className="modal"
        overlayClassName="overlay"
      >
        <div className="modal-header">
          <h2>شروع برنامه</h2>

          <Link to="" onClick={handleCloseDietDate}>
            <span className="icon-iconclose rectangle-1 heading-1 grey-3"></span>
          </Link>
        </div>
        <div className="modal-body">
          <p className="yekan grey-2">از چه تاریخی برنامه رو شروع میکنی؟</p>
          <DatePicker
            inputComponent={DatePickerInput}
            placeholder="انتخاب تاریخ"
            format="jYYYY-jMM-jDD"
            onChange={changeStart}
            id="datePicker"
            preSelected={tomorrowFormatted + "  " + "فردا"}
            containerClass={"grey-1"}
            customClass={"datepicker"}
          />
        </div>

        <div className="modal-footer">
          <Link
            // to={`/Diet?q=${tags}`}
            className="marginBottom0-4r fill-container radius1-5"
            disabled={loading}
            onClick={handleSubmit}
          >
            {loading ? "در حال انتقال..." : "انتقال به تقویم"}
          </Link>
        </div>
      </Modal>
    </>
  );
}
